import Toastify from 'toastify-js'

export const showToast = (text, options = {}) => {
    Toastify({
        text: text,
        position: "center",
        ...options
    }).showToast()
}

